import { RootPage, RootPageTransparentPaper } from "@app/components/RootPage";
import { RootPageHeader } from "@app/components/RootPageHeader";
import { assetClassAnalysisAnalyzePages } from "@app/const/route.const";
import { AssetClassAnalysisSummary } from "./AssetClassAnalysisSummary";
import { SourceDataAsOf } from "@app/pages/assetAllocation/SourceDataAsOf";
import { CarModuleSectionCode } from "@app/hooks/useUserAccess";
import { AccessRouteControl } from "@app/components/AccessRouteControl";
import { AssetClassAnalysisHistoricalAnalysis } from "./AssetClassAnalysisHistoricalAnalysis";
import { AssetClassAnalysisForwardLookingAnalysis } from "./AssetClassAnalysisForwardLookingAnalysis";

export const AssetClassAnalysisAnalyze = () => {
  return (
    <RootPage sx={{ backgroundColor: "white" }}>
      <RootPageHeader
        isSmall
        title="Asset Class Analysis - Analyze"
        items={[
          {
            label: "Summary",
            url: assetClassAnalysisAnalyzePages.summary,
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_SUMMARY,
          },
          {
            label: "Historical Analysis",
            url: assetClassAnalysisAnalyzePages.historicalAnalysisUrl,
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_ANALYSIS_HISTORICAL_ANALYSIS,
          },
          {
            label: "Forward Looking Analysis",
            url: assetClassAnalysisAnalyzePages.forwardLookingAnalysisUrl,
            moduleSection:
              CarModuleSectionCode.ASSET_CLASS_ANALYSIS_FORWARD_LOOKING_ANALYSIS,
          },
        ]}
      />
      <RootPageTransparentPaper>
        <SourceDataAsOf />
        <AccessRouteControl
          items={[
            {
              path: assetClassAnalysisAnalyzePages.summary,
              element: <AssetClassAnalysisSummary />,
              moduleSection:
                CarModuleSectionCode.ASSET_CLASS_MONTHLY_REPORT_SUMMARY,
            },
            {
              path: assetClassAnalysisAnalyzePages.historicalAnalysisPath,
              element: <AssetClassAnalysisHistoricalAnalysis />,
              moduleSection:
                CarModuleSectionCode.ASSET_CLASS_ANALYSIS_HISTORICAL_ANALYSIS,
            },
            {
              path: assetClassAnalysisAnalyzePages.forwardLookingAnalysisPath,
              element: <AssetClassAnalysisForwardLookingAnalysis />,
              moduleSection:
                CarModuleSectionCode.ASSET_CLASS_ANALYSIS_FORWARD_LOOKING_ANALYSIS,
            },
          ]}
          defaultPath={assetClassAnalysisAnalyzePages.summary}
        />
      </RootPageTransparentPaper>
    </RootPage>
  );
};
